export enum ErrorCode {
  REQUIRED = 'REQUIRED',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  TOO_SHORT = 'TOO_SHORT',
  TOO_LONG = 'TOO_LONG',
  DUPLICATE = 'DUPLICATE',
  NOT_FOUND = 'NOT_FOUND',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN = 'UNKNOWN',
  ALREADY_REVIEWED = 'ALREADY_REVIEWED',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}
